import { FC, useCallback, MouseEventHandler } from 'react';
import { TooltipRenderProps } from 'react-joyride';
import { useAsyncFn } from 'react-use';

import { useContextSelector } from 'use-context-selector';
import { useTheme } from 'styled-components';
import classNames from 'classnames';

import { Button } from '../../Button/Button';
import { TourContext } from '../Tour.context';
import { Typography } from '../../Typography/Typography';

import styles from './TourTooltip.module.scss';

export const TourTooltip: FC<TooltipRenderProps> = ({
  size,
  index,
  tooltipProps,
  step: { content },
  closeProps: { onClick: onClose },
  primaryProps: { title: primary, onClick: onPrimary },
}) => {
  const { isMobile } = useTheme();

  const steps = useContextSelector(TourContext, ({ steps }) => steps);

  const onNext = useContextSelector(TourContext, ({ onNext }) => onNext);

  const onCloseOuter = useContextSelector(
    TourContext,
    ({ onClose }) => onClose
  );

  const [{ loading }, dispatch] = useAsyncFn(async () => {
    const { id } = steps[index];
    await onNext({ id });
  });

  const handleOnClose: MouseEventHandler<HTMLIonButtonElement> = useCallback(
    (event) => {
      onClose(event);
      onCloseOuter();
    },
    [onClose, onCloseOuter]
  );

  const handleOnPrimary: MouseEventHandler<HTMLIonButtonElement> = useCallback(
    async (event) => {
      await dispatch();
      onPrimary(event);
    },
    [onPrimary, dispatch]
  );

  return (
    <div
      {...tooltipProps}
      style={{
        width: isMobile ? window.innerWidth - 20 : undefined,
      }}
      className={classNames(styles.root)}
    >
      <div className={styles.header}>
        <Button
          size="s"
          icon="close"
          block={false}
          variant="text"
          onClick={handleOnClose}
        ></Button>
      </div>
      <div className={styles.content}>{content}</div>
      <div className={styles.footer}>
        <Typography color="neutral500" variant="p3">
          {index + 1} / {size}
        </Typography>
        <Button block={false} loading={loading} onClick={handleOnPrimary}>
          {primary}
        </Button>
      </div>
    </div>
  );
};
